import Icon from 'veui/components/Icon'

Icon.register({
  'apps-down': {
    paths: [
      {
        d: 'M320 64H96a32 32 0 00-32 32v224a32 32 0 0032 32h224a32 32 0 0032-32V96a32 32 0 00-32-32zm-32 224H128V128h160zM672 64H448a32 32 0 00-32 32v224a32 32 0 0032 32h224a32 32 0 0032-32V96a32 32 0 00-32-32zm-32 224H480V128h160zM320 416H96a32 32 0 00-32 32v224a32 32 0 0032 32h224a32 32 0 0032-32V448a32 32 0 00-32-32zm-32 224H128V480h160zm374.63-86.63a32 32 0 010 45.26l-96 96a32 32 0 01-45.26 0l-96-96a32 32 0 0145.26-45.26L512 594.74V448a32 32 0 0164 0v146.74l41.37-41.37a32 32 0 0145.26 0z'
      }
    ],
    width: '768',
    height: '768'
  }
})
